export const ErrorCodes = {
  ValidationFailed: 100,
  MappingFailed: 101,
  InvalidState: 102,
  ConfigurationError: 103,
  InvalidRequest: 104,
  InvalidApplicationTypeId: 105,
  InvalidProxySession: 106,
  SubmitFailed: 107,
  WithdrawFailed: 108,
  SessionCheckFailed: 109,
  ApplicationNotFound: 110,
};

const HTTP_STATUS_FORBIDDEN = 403;

const ERROR_MODAL_CONFIGS = {
  forbidden: {
    heading: 'Forbidden Action',
    actions: ({ handleForbiddenAction }) => [
      { label: 'Continue', type: 'primary', onClick: handleForbiddenAction },
    ],
  },
  // Proxy and flow specific? Seems to need re-writing to be generic.
  [ErrorCodes.ApplicationNotFound]: {
    heading: 'The application is no longer in your workspace',
    actions: ({ dismiss, handleLogout }) => [
      { label: 'Dismiss', type: 'secondary', onClick: dismiss },
      { label: 'Go to workspace', type: 'primary', onClick: () => { dismiss(); handleLogout(); } },
    ],
  },
  default: {
    heading: 'The application could not be submitted',
    actions: ({ dismiss }) => [
      { label: 'Close', type: 'primary', onClick: dismiss },
    ],
  },
};

// Resolves the error modal content to render, keyed off the API's status/errorCode instead of nested conditionals.
export const resolveErrorModalConfig = (errorModalState) => {
  if (errorModalState?.status === HTTP_STATUS_FORBIDDEN) {
    return ERROR_MODAL_CONFIGS.forbidden;
  }
  return ERROR_MODAL_CONFIGS[errorModalState?.errorCode] ?? ERROR_MODAL_CONFIGS.default;
};
